import React from 'react';
import {observer} from "mobx-react";
import classNames from "classnames";
import styles from "../styles/competitor-container.module.scss";
import {Outlet, useLocation} from "react-router-dom";
import {useDisplayAdByLayout} from "../../../infrastructure/hooks/useDisplayAdByLayout";
import useAdStatus from "../../../infrastructure/hooks/ads/useAdStatus";
import {CompetitorContainerSideBar} from "./competitor-container.side-bar";
import {ScrollerWrapper} from "../../../core/components/scroll-wrapper/scroll-wrapper";
import {GameCenterWidgetAsync} from "../../../widgets/game-center-widget/components/game-center-widget.async";
import {CompetitorContainerRelatedEntities} from "./competitor-container.related-entities";

export const CompetitorContainerContent = observer(({controller, scrollToTop, shouldRenderAdsBorders}) => {
  const {device, state} = controller;
  const {isWideContainer,
    adConfig,
    shouldRenderAd,
    shouldRenderGame,
    gameContext
  } = state
  const {isSmallView} = device

  const location = useLocation();

  const gameCenterWidgetProps = {
    location,
    gameId: gameContext?.id,
    scrollToTop: () => scrollToTop?.(),
  }

  const {validLayouts, collapseEmptyDiv} = adConfig;
  const {shouldDisplayAd} = useDisplayAdByLayout(controller, validLayouts);
  const {isAdFilled} = useAdStatus(adConfig.adUnit);
  const shouldApplyAdContainer: Boolean = shouldRenderAd && shouldDisplayAd && (isAdFilled || !collapseEmptyDiv);

  return <div className={classNames(styles.container, {[styles.small_view]: isSmallView, [styles.wide_container]: isWideContainer, [styles.ad_container]: shouldApplyAdContainer, [styles.sky_scrapper]: shouldRenderAdsBorders})}>
    <CompetitorContainerSideBar controller={controller}/>
    <ScrollerWrapper wheelPropagation className={classNames(styles.content, {[styles.sticky_main_content]: shouldRenderGame})}>
      {
        shouldRenderGame ? <GameCenterWidgetAsync {...gameCenterWidgetProps} /> : <Outlet/>
      }
      <CompetitorContainerRelatedEntities controller={controller}/>
    </ScrollerWrapper>
  </div>
})
